import { BankOperationCommentsSkeleton } from 'pages/Finance/BankOperations/components/BankOperationCommentsSkeleton';
import { useBankOperationComments } from 'pages/Finance/BankOperations/hooks/useBankOperationComments';
import { RequestsBankOpsShowComment } from 'pages/Finance/RequestsBankOps/RequestsBankOpsShow/RequestsBankOpsShowComment/RequestsBankOpsShowComment';
import { RecordContextProvider, useRecordContext } from 'react-admin';
import { Alert } from 'shared/mui/Alert/Alert';
import { Box } from 'shared/mui/Box';
import { BankOperation } from 'types/embedded/bankOperation';

export const RequestsBankOpsShowTabsComments: React.FC = () => {
  const record = useRecordContext<BankOperation>();
  const { comments, isLoading } = useBankOperationComments(record?.originId);

  if (isLoading) {
    return <BankOperationCommentsSkeleton />;
  }

  return comments.length ? (
    <Box display="flex" flexDirection="column" gap="8px">
      {comments.map((comment) => (
        <RecordContextProvider key={comment.id} value={comment}>
          <RequestsBankOpsShowComment />
        </RecordContextProvider>
      ))}
    </Box>
  ) : (
    <Alert severity="info">Нет комментариев.</Alert>
  );
};
